import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Category from "./pages/Category";
import Article from "./pages/Article";
import Admin from "./pages/Admin";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import Payouts from "./pages/Payouts";
import Rewards from "./pages/Rewards";
import Contact from "./pages/Contact";
import Archives from "./pages/Archives";
import ForeignStations from "./pages/ForeignStations";
import Networks from "./pages/Networks";
import Extension from "./pages/Extension";
import Sellpages from "./pages/Sellpages";
import ExternalRead from "./pages/ExternalRead";
import Legal from "./pages/Legal";
import Students from "./pages/Students";
import Benefits from "./pages/Benefits";
import Newsroom from "./pages/Newsroom";
import Trust from "./pages/Trust";
import ResetPassword from "./pages/ResetPassword";
import Newsstand from "./pages/Newsstand";
import OtherVoices from "./pages/OtherVoices";
import Connect from "./pages/Connect";
import ReaderTools from "./pages/ReaderTools";
import ScoredShare from "./pages/ScoredShare";
import Security from "./pages/Security";
import Lens from "./pages/Lens";
import CyberCenter from "./pages/CyberCenter";
import { ColumnsIndex } from "./pages/Column";
import ColumnPage from "./pages/Column";
import { AuthProvider } from "./auth/AuthContext";
import { RouteSeo } from "./components/SeoHead";

const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "";

function App() {
  useEffect(() => {
    if (!ADSENSE_CLIENT || document.getElementById("adsense-loader")) return;
    const s = document.createElement("script");
    s.id = "adsense-loader";
    s.async = true;
    s.crossOrigin = "anonymous";
    s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
    document.head.appendChild(s);
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <RouteSeo />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/news" element={<Category />} />
            <Route path="/section/:cat" element={<Category />} />
            <Route path="/article/:id" element={<Article />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
            <Route path="/payouts" element={<Payouts />} />
            <Route path="/rewards" element={<Rewards />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/archives" element={<Archives />} />
            <Route path="/section/foreign" element={<ForeignStations />} />
            <Route path="/networks" element={<Networks />} />
            <Route path="/networks/:id" element={<Networks />} />
            <Route path="/extension" element={<Extension />} />
            <Route path="/sellpages" element={<Sellpages />} />
            <Route path="/read/:id" element={<ExternalRead />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/students" element={<Students />} />
            <Route path="/benefits" element={<Benefits />} />
            <Route path="/newsroom" element={<Newsroom />} />
            <Route path="/trust" element={<Trust />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/newsstand" element={<Newsstand />} />
            <Route path="/other-voices" element={<OtherVoices />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="/reader-tools" element={<ReaderTools />} />
            <Route path="/scored/:id" element={<ScoredShare />} />
            <Route path="/security" element={<Security />} />
            <Route path="/lens" element={<Lens />} />
            <Route path="/cyber" element={<CyberCenter />} />
            <Route path="/columns" element={<ColumnsIndex />} />
            <Route path="/columns/:slug" element={<ColumnPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
